<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col w-11/12 md:w-3/5 lg:w-2/5 sm:m-0 m-0">
      <vx-card class="rounded p-5 sm:p-10 sm:px-20">
        <div class="vx-card__title mb-4">
          <h4 class="text-center text-3xl sm:text-4xl">Login</h4>
        </div>
        <form @submit.prevent="login" class="mt-5">
          <ResponseAlert ref="response" />
          <div class="vx-col w-full my-5">
            <vs-input 
                v-validate="'required|email'" 
                type="email"
                label="Email" 
                name="email" 
                icon-no-border
                icon="icon icon-user"
                icon-pack="feather"
                v-model="models.emailOrPhoneNum" 
                class="w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
          <div class="vx-col w-full relative">
            <vs-input 
                @keydown.space.prevent
                v-validate="'required'" 
                label="Password" 
                name="password" 
                icon-no-border
                icon="icon icon-lock"
                icon-pack="feather"
                :type="vars.type.password"
                v-model="models.password" 
                class="w-full"/>
            <vs-icon icon-pack="feather" @click="togglePassword" icon="icon icon-eye" class="absolute cursor-pointer" style="top: 34px; right: 10px"></vs-icon>

            <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="flex flex-wrap justify-end my-5">
            <router-link to="/recover">Forgot Password?</router-link>
          </div>
          <vs-button button="submit" type="filled" color="primary" class="w-full">Login</vs-button>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      models: {
        emailOrPhoneNum: "",
        password: "",
        isAdmin: true
      },
      vars: {
        type: {
          password: 'password'
        }
      }
    }
  },
  methods: {
    login(){
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$axios.post('auth/login', this.models)
          .then(resp => {
						this.$showToast('Success', `Success login`)
            this.$store.dispatch('login',resp.data.data)
          })
          .catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
        }
      });
    },
    togglePassword() {
      this.vars.type.password = this.vars.type.password === 'password' ? 'text' : 'password'
    }
  }
}
</script>